(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = plan();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.plan = plan();
    }

    function plan() {

        return {
            purchaseRestriction: {
                NONE: 0,
                CURRENT_PLAN: 1,
                OFFLINE_ONLY: 2,
                OVER_COMPANY_LIMIT: 3,
                OVER_LANDSCAPE_LIMIT: 4,
                BREAKS_ANNUAL_COMMITMENT: 5,
                ANNUAL_PLAN_CHANGE: 6,
                COMPED: 7,
                CHURNED: 8,
                LEGACY_PLAN: 9,
                OVER_LISTENING_SAVED_SEARCHES_LIMIT: 10
            },
            type: {
                TRIAL: 'trial',
                CUSTOM: 'custom'
            },
            commitmentType: {
                ANNUAL: 'annual',
                MONTHLY: 'monthly'
            }
        };
    }
})();
